import { useState, useEffect } from 'react';
import '../App.css';
import chip1 from '../img/chips/chip-1.svg'
import chip2 from '../img/chips/chip-2.svg'
import chip5 from '../img/chips/chip-5.svg'
import chip10 from '../img/chips/chip-10.svg'
import chip25 from '../img/chips/chip-25.svg'
import chip50 from '../img/chips/chip-50.svg'
import chip100 from '../img/chips/chip-100.svg'
import Number from './Number';

function BetTable(props) {

    const [chipImage, setChipImage] = useState(chip1)

    const [oneToEighteen, setOneToEighteen] = useState(0)
    const [evenNumber, setEvenNumber] = useState(0)
    const [oddNumber, setOddNumber] = useState(0)
    const [redNumber, setRedNumber] = useState(0)
    const [blackNumber, setBlackNumber] = useState(0)
    const [nineteenToThirtySix, setNineteenToThirtySix] = useState(0)
    const [firstDozen, setFirstDozen] = useState(0)
    const [secondDozen, setSecondDozen] = useState(0)
    const [thirdDozen, setThirdDozen] = useState(0)
    const [firstColumn, setFirstColumn] = useState(0)
    const [secondColumn, setSecondColumn] = useState(0)
    const [thirdColumn, setThirdColumn] = useState(0)
    const [zero, setZero] = useState(0)

    /* POPUP  */

    const [minusValue, setMinusValue] = useState(0)

    useEffect(() => {
        if (props.activeChip === 1) {
            setChipImage(chip1)
        } else if (props.activeChip === 2) {
            setChipImage(chip2)
        } else if (props.activeChip === 5) {
            setChipImage(chip5)
        } else if (props.activeChip === 10) {
            setChipImage(chip10)
        } else if (props.activeChip === 25) {
            setChipImage(chip25)
        } else if (props.activeChip === 50) {
            setChipImage(chip50)
        } else if (props.activeChip === 100) {
            setChipImage(chip100)
        }
    }, [props.activeChip])

    const [numbers, setNumbers] = useState([
        {
            number: 1,
            hover: false,
            values: []
        },
        {
            number: 2,
            hover: false,
            values: []
        },
        {
            number: 3,
            hover: false,
            values: []
        },
        {
            number: 4,
            hover: false,
            values: []
        },
        {
            number: 5,
            hover: false,
            values: []
        },
        {
            number: 6,
            hover: false,
            values: []
        },
        {
            number: 7,
            hover: false,
            values: []
        },
        {
            number: 8,
            hover: false,
            values: []
        },
        {
            number: 9,
            hover: false,
            values: []
        },
        {
            number: 10,
            hover: false,
            values: []
        },
        {
            number: 11,
            hover: false,
            values: []
        },
        {
            number: 12,
            hover: false,
            values: []
        },
        {
            number: 13,
            hover: false,
            values: []
        }
        ,
        {
            number: 14,
            hover: false,
            values: []
        },
        {
            number: 15,
            hover: false,
            values: []
        },
        {
            number: 16,
            hover: false,
            values: []
        },
        {
            number: 17,
            hover: false,
            values: []
        },
        {
            number: 18,
            hover: false,
            values: []
        },
        {
            number: 19,
            hover: false,
            values: []
        },
        {
            number: 20,
            hover: false,
            values: []
        },
        {
            number: 21,
            hover: false,
            values: []
        },
        {
            number: 22,
            hover: false,
            values: []
        },
        {
            number: 23,
            hover: false,
            values: []
        },
        {
            number: 24,
            hover: false,
            values: []
        },
        {
            number: 25,
            hover: false,
            values: []
        },
        {
            number: 26,
            hover: false,
            values: []
        },
        {
            number: 27,
            hover: false,
            values: []
        },
        {
            number: 28,
            hover: false,
            values: []
        },
        {
            number: 29,
            hover: false,
            values: []
        },
        {
            number: 30,
            hover: false,
            values: []
        },
        {
            number: 31,
            hover: false,
            values: []
        },
        {
            number: 32,
            hover: false,
            values: []
        },
        {
            number: 33,
            hover: false,
            values: []
        },
        {
            number: 34,
            hover: false,
            values: []
        },
        {
            number: 35,
            hover: false,
            values: []
        },
        {
            number: 36,
            hover: false,
            values: []
        }
    ])

    function hightlight2to1(start) {
        var result = [];
        var nextNumber = start;

        numbers.forEach(number => {
            if (number.number === nextNumber) {
                number.hover = true;
                nextNumber = number.number + 3;
            }

            result.push(number)
        });

        setNumbers(result)
    }

    function cancelHighlight() {
        var result = [];
        for (var number of numbers) {
            number.hover = false;
            result.push(number)
        }
        setNumbers(result)
    }

    function selectFromToHighLight(min, max) {
        var result = [];

        numbers.forEach(number => {
            if (number.number > min - 1 && number.number < max + 1) {
                number.hover = true;
            }

            result.push(number)
        });

        setNumbers(result)
    }

    var red = [32, 19, 21, 25, 34, 27, 36, 30, 23, 5, 16, 1, 14, 9, 18, 7, 12, 3];

    function selectNumber(num) {

        var result = [];

        if (num === 'even') {
            let i = 1
            while (i <= 36) {
                if (i % 2 == 0) {
                    var number = numbers[i - 1];
                    number.hover = true;
                    result.push(number)
                } else {
                    var number = numbers[i - 1];
                    number.hover = false;
                    result.push(number)
                }
                i++
            }
        } else {
            let i = 1
            while (i <= 36) {
                if (i % 2 != 0) {
                    var number = numbers[i - 1];
                    number.hover = true;
                    result.push(number)
                } else {
                    var number = numbers[i - 1];
                    number.hover = false;
                    result.push(number)
                }
                i++
            }
        }

        setNumbers(result)
    }


    function selectByColor(color) {

        var result = [];

        numbers.forEach(number => {
            if (color === 'red') {
                if (red.indexOf(number.number) !== -1) {
                    number.hover = true;
                }
            } else {
                if (red.indexOf(number.number) === -1) {
                    number.hover = true;
                }
            }
            result.push(number)
        });
        setNumbers(result)
    }

    function addMultipleValues(selectedNumbers) {
        var result = []

        numbers.forEach(number => {
            if (selectedNumbers.find(e => e === number.number) !== undefined) {

                if (number.values.find(el => el.position === 'side') !== undefined) {
                    var existingNumber = number;
                    const index = existingNumber.values.findIndex(el => el.position === 'side')
                    existingNumber.values[index].value = existingNumber.values[index].value + props.activeChip;
                    result.push(existingNumber)
                } else {
                    var existingNumber = number;
                    existingNumber.values.push({
                        position: 'side',
                        value: props.activeChip,
                        type: '',
                        number: existingNumber.number
                    })
                    result.push(number)
                }
            } else {
                result.push(number)
            }
        });

        setNumbers(result)
    }

    function addMultipleValues1To12(selectedNumbers) {
        var result = []

        numbers.forEach(number => {
            if (selectedNumbers.find(e => e === number.number) !== undefined) {

                if (number.values.find(el => el.position === 'side_1_12') !== undefined) {
                    var existingNumber = number;
                    const index = existingNumber.values.findIndex(el => el.position === 'side_1_12')
                    existingNumber.values[index].value = existingNumber.values[index].value + props.activeChip;
                    result.push(existingNumber)
                } else {
                    var existingNumber = number;
                    existingNumber.values.push({
                        position: 'side_1_12',
                        value: props.activeChip,
                        type: '1to12',
                        number: existingNumber.number,
                    })
                    result.push(number)
                }
            } else {
                result.push(number)
            }
        });

        setNumbers(result)
    }

    function addMultipleValues1To18(selectedNumbers) {
        var result = []

        let i = 1
        var even = []
        var odd = []
        while (i <= 36) {
            if (i % 2 == 0) {
                even.push(i)
            } else {
                odd.push(i)
            }
            i++
        }

        numbers.forEach(number => {
            if (selectedNumbers.find(e => e === number.number) !== undefined) {

                if (number.values.find(el => el.position === 'side_1_18') !== undefined) {
                    var existingNumber = number;
                    const index = existingNumber.values.findIndex(el => el.position === 'side_1_18')
                    existingNumber.values[index].value = existingNumber.values[index].value + props.activeChip;
                    result.push(existingNumber)
                } else {
                    var existingNumber = number;
                    existingNumber.values.push({
                        position: 'side_1_18',
                        value: props.activeChip,
                        type: '1to18',
                        even: even.indexOf(number.number) !== -1 ? true : false,
                        nums: selectedNumbers.indexOf(18) !== -1 ? 'first' : 'second'
                    })
                    result.push(number)
                }
            } else {
                result.push(number)
            }
        });

        setNumbers(result)
    }

    function addMultipleValuesColor(selectedNumbers) {
        var result = []

        numbers.forEach(number => {
            if (selectedNumbers.find(e => e === number.number) !== undefined) {

                if (number.values.find(el => el.position === 'side_1_18') !== undefined) {
                    var existingNumber = number;
                    const index = existingNumber.values.findIndex(el => el.position === 'side_1_18')
                    existingNumber.values[index].value = existingNumber.values[index].value + props.activeChip;
                    result.push(existingNumber)
                } else {
                    var existingNumber = number;
                    existingNumber.values.push({
                        position: 'side_1_18',
                        value: props.activeChip,
                        type: 'color',
                        number: existingNumber.number
                    })
                    result.push(number)
                }
            } else {
                result.push(number)
            }
        });

        setNumbers(result)
    }


    function getColor(number) {
        return number !== undefined ? number > 99 ? 'active-color--violet' : number > 49 ? 'active-color--orange' : number > 24 ? 'active-color--blue' : number > 9 ? 'active-color--green' : number > 4 ? 'active-color--pink' : number > 1 ? 'active-color--light-violet' : '' : ''
    }

    function calculateWinning() {

        var result = [];

        var orig = numbers;

        for (var number of numbers) {

            var usedCenterBets = 0;
            var centerBets = 0;
            var rightBets = 0;
            var topBets = 0;
            var fourBets = 0;
            var sideBets = 0
            var sideOnetoTwelveBets = 0;
            var sideOneToNineTeen = 0;

            numbers.forEach(number => {
                if (number.values.find(e => e.position === 'center') !== undefined) {
                    centerBets++
                }

                if (number.values.find(e => e.position === 'right') !== undefined) {
                    rightBets++
                }

                if (number.values.find(e => e.position === 'top') !== undefined) {
                    topBets++
                }

                if (number.values.find(e => e.position === 'four') !== undefined) {
                    fourBets++
                }

                if (number.values.find(e => e.position === 'side') !== undefined) {
                    sideBets++
                }

                if (number.values.find(e => e.position === 'side_1_12') !== undefined) {
                    sideOnetoTwelveBets++
                }

                if (number.values.find(e => e.position === 'side_1_18') !== undefined) {
                    sideOneToNineTeen++
                }
            });


            if (fourBets === 1) {
                fourBets = 0;
            }

            topBets = topBets - 1;
            rightBets = rightBets - 1;
            centerBets = centerBets - 1;
            sideBets = sideBets - 1

            var minusValue = -1;

            usedCenterBets = centerBets;

            /* MINUS */



            var minusCenter = 0;
            var minusRight = 0;
            var minusTop = 0;
            var minusFour = 0;

            numbers.forEach(number => {
                if (number.values.find(e => e.position === 'center') !== undefined) {
                    minusCenter++
                }

                if (number.values.find(e => e.position === 'right') !== undefined) {
                    minusRight++
                }

                if (number.values.find(e => e.position === 'top') !== undefined) {
                    minusTop++
                }

                if (number.values.find(e => e.position === 'four') !== undefined) {
                    minusFour++
                }
            });


            var summa = minusCenter + minusRight + minusTop + minusFour;
            minusValue = 0 - summa + zeroMinus;
            setMinusValue(minusValue)


            if (number.values.find(e => e.position === 'center') !== undefined) {

                /* Center value calculate */

                const index = number.values.findIndex(el => el.position === 'center')
                minusValue = minusValue - (-1 * (centerBets * number.values[index].value))
                number.values[index] = { ...number.values[index], calculated: (35 - centerBets) * number.values[index].value, minus: minusValue, number: number.number };
            }

            if (number.values.find(e => e.position === 'right') !== undefined) {

                /* Right value calculate */

                const index = number.values.findIndex(el => el.position === 'right')
                minusValue = minusValue - (-1 * (rightBets * number.values[index].value))
                number.values[index] = { ...number.values[index], calculated: (17 - rightBets) * number.values[index].value, minus: minusValue, number: number.number };

            }

            if (number.values.find(e => e.position === 'top') !== undefined) {

                /* Top value calculate */

                const index = number.values.findIndex(el => el.position === 'top')
                minusValue = minusValue - (-1 * (topBets * number.values[index].value))
                number.values[index] = { ...number.values[index], calculated: (17 - topBets) * number.values[index].value, minus: minusValue, number: number.number };

            }

            if (number.values.find(e => e.position === 'four') !== undefined) {

                /* Four value calculate */

                const index = number.values.findIndex(el => el.position === 'four')
                minusValue = minusValue - (-1 * (fourBets * number.values[index].value))
                number.values[index] = { ...number.values[index], calculated: (8 - fourBets) * number.values[index].value, minus: minusValue, number: number.number };

            }

            if (number.values.find(e => e.position === 'side_1_12') !== undefined) {

                /* Four value calculate */

                const index = number.values.findIndex(el => el.position === 'side_1_12')
                var minusValue = -1
                number.values[index] = { ...number.values[index], calculated: (sideOnetoTwelveBets === 12 ? 2 : sideOnetoTwelveBets === 24 ? 1 : 0) * number.values[index].value, minus: minusValue, number: number.number };

                if (sideOnetoTwelveBets === 12) {
                    setMinusValue(-1)
                } else if (sideOnetoTwelveBets === 24) {
                    setMinusValue(-2)
                } else {
                    setMinusValue(-3)
                }
            }

            if (number.values.find(e => e.position === 'side_1_18') !== undefined) {

                /* Four value calculate */

                const index = number.values.findIndex(el => el.position === 'side_1_18')
                var minusValue = -1
                number.values[index] = { ...number.values[index], calculated: (sideOneToNineTeen === 18 ? 1 : sideOneToNineTeen === 24 ? 1 : 0) * number.values[index].value, minus: minusValue, number: number.number };
            }

            if (number.values.find(e => e.position === 'side') !== undefined) {

                /* Side value calculate */

                const index = number.values.findIndex(el => el.position === 'side')
                var minusValue = -1
                if (number.values[index].type !== undefined) {
                    if (number.values[index].type === '4values') {

                        var fullValue = 0;

                        number.values.forEach(num => {
                            if (num.position === 'side') {
                                fullValue = fullValue + (8 * num.value)
                            }
                        });
                        number.values[0] = { ...number.values[0], calculated: fullValue, minus: minusValue, number: number.number };

                    } else if (number.values[index].type === 'color') {
                        var fullValue = 0;

                        number.values.forEach(num => {
                            if (num.position === 'side') {
                                fullValue = fullValue + (35 * num.value)
                            }
                        });
                        number.values[0] = { ...number.values[0], calculated: fullValue, minus: minusValue, number: number.number };
                    }
                } else {
                    number.values[index] = { ...number.values[index], calculated: (17) * number.values[index].value, minus: minusValue, number: number.number };
                }
            }
            result.push(number)
        }

        setNumbers(result)
        setZeroWinning(zero * 35)
    }

    const [zeroWinning, setZeroWinning] = useState(0)

    useEffect(() => {
        if (props.wheelSpin === true) {
            calculateWinning()
        }

    }, [props.wheelSpin])

    const [zeroMinus, setZeroMinus] = useState(0)

    function addMinusZero() {
        setZeroMinus(zeroMinus - 1)
    }

    const [sideValues, setSideValues] = useState([
        {
            name: '1to18',
            value: 0
        },
        {
            name: '1st12',
            value: 0,
        },
        {
            name: 'even',
            value: 0,
        },
        {
            name: 'red',
            value: 0,
        },
        {
            name: 'black',
            value: 0,
        },
        {
            name: '2nd12',
            value: 0,
        },
        {
            name: 'odd',
            value: 0,
        },
        {
            name: '19to36',
            value: 0,
        },
        {
            name: '3rd12',
            value: 0,
        },
        {
            name: '2to1_first',
            value: 0,
        },
        {
            name: '2to1_second',
            value: 0,
        },
        {
            name: '2to1_third',
            value: 0,
        },
        {
            name: 'zero',
            value: 0,
        },
        {
            name: 'db_zero',
            value: 0,
        }
    ])

    // Efecto para sincronizar datos con el componente padre
    useEffect(() => {
        if (props.setNumbers && numbers) {
            props.setNumbers([...numbers]);
        }
    }, [numbers, props.setNumbers]);

    useEffect(() => {
        if (props.setSideValues && sideValues) {
            props.setSideValues([...sideValues]);
        }
    }, [sideValues, props.setSideValues]);

    function calc1to18(position) {
        var currentValue = sideValues.find(e => e.name === position).value;

        if (currentValue !== undefined) {
            currentValue = currentValue + (props.activeChip * 1)

            var res = sideValues;

            res.map((item, index) => {
                if (item.name === position) {
                    if (item.name === 'zero' || item.name === 'db_zero') {
                        item.value = currentValue
                    } else {
                        item.value = currentValue
                    }
                    
                }
            })

            setSideValues(res)
        }
    }

    const OneToEleven = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24]

    return (
        <div class="combined-calculator__table py-6 pb-2 md:pb-6">
            <table class="combined-calculator_table rubik" style={{ cursor: 'url(' + chipImage + ') 10 10, pointer' }}>
                <tbody class="value-table">
                    <tr class="combined-calculator_table-row">
                        <td colspan="2" class="not-border"></td>
                        <td class="last-empty"></td>
                    </tr>
                    <tr class="combined-calculator_table-row">

                        <td rowspan="2" data-value="18" onClick={props.wheelSpin === false ? e => {
                            addMultipleValues1To18([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18])
                            calc1to18('1to18')
                            setOneToEighteen(oneToEighteen + props.activeChip)
                        }
                            : null
                        } onMouseEnter={e => selectFromToHighLight(1, 18)} onMouseLeave={e => cancelHighlight()}>
                            <span data-value={props.wheelSpin === false ? oneToEighteen !== 0 ? oneToEighteen : null : ''} className={`number-table text-rotate ${props.wheelSpin === true && sideValues.find(e => e.name === '1to18').value ? 'table-number-value win-color--blue minusResult' : oneToEighteen !== 0 ? getColor(oneToEighteen) + ' active-cursor' : ''}`}>
                                {props.wheelSpin === true && sideValues.find(e => e.name === '1to18').value ? (props.winnerValue < 19 && props.winnerValue > 0) ? '+' + sideValues.find(e => e.name === '1to18').value : '-' + sideValues.find(e => e.name === '1to18').value : '1 to 18'}</span>
                        </td>

                        <td rowspan="4" class="not-border_right not-border_bottom red_fix" data-value="1st 12"
                            onMouseEnter={e => selectFromToHighLight(1, 12)}
                            onMouseLeave={e => cancelHighlight()}
                            onClick={props.wheelSpin === false ? e => {
                                addMultipleValues1To12([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])
                                calc1to18('1st12')
                                setFirstDozen(firstDozen + props.activeChip)
                            }
                                : null
                            }>
                            <span
                                data-value={props.wheelSpin === false ? firstDozen !== 0 ? firstDozen : null : ''}
                                className={`number-table text-rotate border-text ${props.wheelSpin === true && sideValues.find(e => e.name === '1st12').value ? 'table-number-value win-color--blue minusResult' : firstDozen !== 0 ? getColor(firstDozen) + ' active-cursor' : ''}`}
                            >{props.wheelSpin === true && sideValues.find(e => e.name === '1st12').value ? (props.winnerValue < 13 && props.winnerValue > 0) ? '+' + sideValues.find(e => e.name === '1st12').value * 2 : '-' + sideValues.find(e => e.name === '1st12').value : '1st 12'}</span>
                        </td>
                        <td class="last-empty"></td>
                    </tr>
                    <tr class="combined-calculator_table-row">
                        <td class="last-empty"></td>
                    </tr>
                    <tr class="combined-calculator_table-row">
                        <td rowspan="2" class="not-border_right not-border_bottom"
                            onMouseEnter={e => selectNumber('even')}
                            onMouseLeave={e => cancelHighlight()}
                            onClick={props.wheelSpin === false ? e => {
                                let i = 1
                                var even = []
                                while (i <= 36) {
                                    if (i % 2 == 0) {
                                        even.push(i)
                                    }
                                    i++
                                }
                                calc1to18('even')
                                addMultipleValues1To18(even)
                                setEvenNumber(evenNumber + props.activeChip)
                            } : null}
                        >
                            <span data-value={props.wheelSpin === false ? evenNumber !== 0 ? evenNumber : null : ''}
                                className={`number-table text-rotate ${props.wheelSpin === true && sideValues.find(e => e.name === 'even').value ? 'table-number-value win-color--blue minusResult' : evenNumber !== 0 ? getColor(evenNumber) + ' active-cursor' : ''}`}>
                                {props.wheelSpin === true && sideValues.find(e => e.name === 'even').value ?
                                    (props.winnerValue % 2 === 0)
                                        ? '+' + sideValues.find(e => e.name === 'even').value : '-' + sideValues.find(e => e.name === 'even').value : 'EVEN'}
                            </span>
                        </td>
                        <td class="last-empty"></td>
                    </tr>
                    <tr class="combined-calculator_table-row">
                        <td class="last-empty"></td>
                    </tr>
                    <tr class="combined-calculator_table-row">
                        <td rowspan="2" data-value="red" class="not-border_right not-border_bottom bg-clifford redValue"
                            onMouseEnter={e => selectByColor('red')}
                            onMouseLeave={e => cancelHighlight()}
                            onClick={props.wheelSpin === false ? e => {
                                addMultipleValuesColor(red)
                                calc1to18('red')
                                setRedNumber(redNumber + props.activeChip)
                            } : null}
                        >
                            <span
                                data-value={props.wheelSpin === false ? redNumber !== 0 ? redNumber : null : ''}
                                className={`ovalinfo oval red text-rotate red-bet ${props.wheelSpin === true && sideValues.find(e => e.name === 'red').value ? 'table-number-value win-color--blue minusResult' : redNumber !== 0 ? getColor(redNumber) + ' active-cursor' : ''}`}>
                                {props.wheelSpin === true && sideValues.find(e => e.name === 'red').value ?
                                    (red.find(e => e == props.winnerValue) !== undefined)
                                        ? '+' + sideValues.find(e => e.name === 'red').value : '-' + sideValues.find(e => e.name === 'red').value : 'RED'}
                            </span>
                        </td>
                        <td rowspan="4" class="not-border_right not-border_bottom red_fix"
                            data-value="2nd 12"
                            onMouseEnter={e => selectFromToHighLight(13, 24)}
                            onMouseLeave={e => cancelHighlight()}
                            onClick={props.wheelSpin === false ? e => {
                                addMultipleValues1To12([13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24])
                                calc1to18('2nd12')
                                setSecondDozen(secondDozen + props.activeChip)
                            } : null}
                        >
                            <span
                                className={`number-table text-rotate border-text ${props.wheelSpin === true && sideValues.find(e => e.name === '2nd12').value ? 'table-number-value win-color--blue minusResult' : secondDozen !== 0 ? getColor(secondDozen) + ' active-cursor' : ''}`}
                                data-value={props.wheelSpin === false ? secondDozen !== 0 ? secondDozen : null : ''}
                            >{props.wheelSpin === true && sideValues.find(e => e.name === '2nd12').value ?
                                OneToEleven.find(e => e == props.winnerValue) !== undefined
                                    ? '+' + sideValues.find(e => e.name === '2nd12').value * 2 : '-' + sideValues.find(e => e.name === '2nd12').value : '2nd 12'}</span>
                        </td>
                        <td class="last-empty"></td>
                    </tr>
                    <tr class="combined-calculator_table-row">
                        <td class="last-empty"></td>
                    </tr>
                    <tr class="combined-calculator_table-row">
                        <td rowspan="2" class="not-border_right not-border_bottom bg-black"
                            data-value="black"
                            onMouseEnter={e => selectByColor('black')}
                            onMouseLeave={e => cancelHighlight()}
                            onClick={props.wheelSpin === false ? e => {
                                var black = []
                                let i = 1
                                while (i <= 36) {
                                    if (red.indexOf(i) === -1) {
                                        black.push(i)
                                    }
                                    i++
                                }
                                calc1to18('black')
                                addMultipleValuesColor(black)
                                setBlackNumber(blackNumber + props.activeChip)
                            } : null}
                        >
                            <span class="ovalinfo">
                                <span
                                    className={`text-rotate ${props.wheelSpin === true && sideValues.find(e => e.name === 'black').value ? 'table-number-value win-color--blue minusResult' : blackNumber !== 0 ? getColor(blackNumber) + ' active-cursor' : ''}`}
                                    data-value={props.wheelSpin === false ? blackNumber !== 0 ? blackNumber : null : ''}
                                >{props.wheelSpin === true && sideValues.find(e => e.name === 'black').value ?
                                    (red.find(e => e == props.winnerValue) === undefined)
                                        ? '+' + sideValues.find(e => e.name === 'black').value : '-' + sideValues.find(e => e.name === 'black').value : 'BLACK'}</span>
                            </span>
                        </td>
                        <td class="last-empty"></td>
                    </tr>
                    <tr class="combined-calculator_table-row">
                        <td class="last-empty"></td>
                    </tr>
                    <tr class="combined-calculator_table-row">
                        <td rowspan="2" data-value="odd" class="not-border_right not-border_bottom"
                            onMouseEnter={e => selectNumber('odd')}
                            onMouseLeave={e => cancelHighlight()}
                            onClick={props.wheelSpin === false ? e => {
                                let i = 1
                                var odd = []
                                while (i <= 36) {
                                    if (i % 2 != 0) {
                                        odd.push(i)
                                    }
                                    i++
                                }
                                addMultipleValues1To18(odd)
                                calc1to18('odd')
                                setOddNumber(oddNumber + props.activeChip)
                            } : null}
                        >
                            <span data-value={props.wheelSpin === false ? oddNumber !== 0 ? oddNumber : null : ''}
                                className={`number-table text-rotate ${props.wheelSpin === true && sideValues.find(e => e.name === 'odd').value ? 'table-number-value win-color--blue minusResult' : oddNumber !== 0 ? getColor(oddNumber) + ' active-cursor' : ''}`}>
                                {props.wheelSpin === true && sideValues.find(e => e.name === 'odd').value ?
                                    (props.winnerValue % 2 !== 0)
                                        ? '+' + sideValues.find(e => e.name === 'odd').value : '-' + sideValues.find(e => e.name === 'odd').value : 'ODD'}
                            </span>
                        </td>
                        <td rowspan="4" class="not-border_right red_fix" data-value="3rd 12"
                            onMouseEnter={e => selectFromToHighLight(25, 36)}
                            onMouseLeave={e => cancelHighlight()}
                            onClick={props.wheelSpin === false ? e => {
                                addMultipleValues1To12([25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36])
                                calc1to18('3rd12')
                                setThirdDozen(thirdDozen + props.activeChip)
                            } : null}
                        >
                            <span data-value={props.wheelSpin === false ? thirdDozen !== 0 ? thirdDozen : null : ''}
                                className={`number-table text-rotate border-text ${props.wheelSpin === true && sideValues.find(e => e.name === '3rd12').value ? 'table-number-value win-color--blue minusResult' : thirdDozen !== 0 ? getColor(thirdDozen) + ' active-cursor' : ''}`}>
                                {
                                    props.wheelSpin === true && sideValues.find(e => e.name === '3rd12').value ?
                                        ([25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36].find(e => e == props.winnerValue) !== undefined)
                                            ? '+' + sideValues.find(e => e.name === '3rd12').value * 2 : '-' + sideValues.find(e => e.name === '3rd12').value : '3rd 12'
                                }

                            </span>
                        </td>
                        <td class="last-empty"></td>
                    </tr>
                    <tr class="combined-calculator_table-row">
                        <td class="last-empty"></td>
                    </tr>
                    <tr class="combined-calculator_table-row">
                        <td rowspan="2" class="not-border_right" data-value="36"
                            onMouseEnter={e => selectFromToHighLight(19, 36)}
                            onMouseLeave={e => cancelHighlight()}
                            onClick={props.wheelSpin === false ? e => {
                                addMultipleValues1To18([19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36])
                                calc1to18('19to36')
                                setNineteenToThirtySix(nineteenToThirtySix + props.activeChip)
                            } : null}
                        >
                            <span data-value={props.wheelSpin === false ? nineteenToThirtySix !== 0 ? nineteenToThirtySix : null : ''}
                                className={`number-table text-rotate ${props.wheelSpin === true && sideValues.find(e => e.name === '19to36').value ? 'table-number-value win-color--blue minusResult' : nineteenToThirtySix !== 0 ? getColor(nineteenToThirtySix) + ' active-cursor' : ''}`}
                            >
                                {
                                    props.wheelSpin === true && sideValues.find(e => e.name === '19to36').value ?
                                        ([19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36].find(e => e == props.winnerValue) !== undefined)
                                            ? '+' + sideValues.find(e => e.name === '19to36').value : '-' + sideValues.find(e => e.name === '19to36').value : '19 to 36'
                                }

                            </span>
                        </td>
                        <td class="last-empty"></td>
                    </tr>
                    <tr class="combined-calculator_table-row plus-height">
                        <td class="last-empty"></td>
                    </tr>
                    <tr class="combined-calculator_table-row bg_bottom">
                        <td colspan="2" class="not-border"></td>
                        <td class="last-empty"></td>
                    </tr>
                </tbody>
                <tbody class="oval-table">
                    <div class="combined-calculator_table-row--zero brs-left brs-right">
                        <div class="zero"
                            onClick={props.wheelSpin === false ? e => {
                                addMultipleValues([0])
                                addMinusZero()
                                setZero(zero + props.activeChip)
                                calc1to18('zero')
                            } : null}
                        >
                            <span data-value={zeroWinning === 0 ? zero !== 0 ? zero : null : props.winnerValue !== 38 ? sideValues.find(e => e.name === 'zero').value * -1 : sideValues.find(e => e.name === 'zero').value * 35}
                                className={`oval green ${zeroWinning === 0 ? zero !== 0 ? getColor(zero) + ' active-cursor' : '' : 'active-color--green win-color--violet'}`}>{props.wheelSpin === 'ended' ? props.winnerValue !== 38 ? sideValues.find(e => e.name === 'zero').value * -1 : sideValues.find(e => e.name === 'zero').value * 35 : '0'}</span>
                        </div>
                    </div>


                    <div class="ovalNumber grid grid-cols-3">
                        {
                            (numbers.length > 0)
                                ? numbers.map(item => (
                                    <Number winnerValue={props.winnerValue} zeroMinus={zeroMinus} minus={minusValue} data={item} betValue={props.activeChip} numbers={numbers} setNumbers={setNumbers} cancelHighlight={cancelHighlight} wheelSpin={props.wheelSpin} />
                                ))
                                : ''
                        }
                    </div>


                    <div class="combined-calculator_table-row">
                        <td data-value="2 to 1"
                            onMouseEnter={e => hightlight2to1(1)}
                            onMouseLeave={e => cancelHighlight()}
                            onClick={props.wheelSpin === false ? e => {
                                addMultipleValues1To12([1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34])
                                calc1to18('2to1_first')
                                setFirstColumn(firstColumn + props.activeChip)
                            } : null}
                        >
                            <span data-value={props.wheelSpin === false ? firstColumn !== 0 ? firstColumn : null : ''}
                                className={`bottom-row number-table vertical-number-1 ${props.wheelSpin === true && sideValues.find(e => e.name == '2to1_first').value ? 'table-number-value win-color--blue minusResult' : firstColumn !== 0 ? getColor(firstColumn) + ' active-cursor' : ''}`}>

                                {
                                    props.wheelSpin === true && sideValues.find(e => e.name === '2to1_first').value ?
                                        ([1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34].find(e => e == props.winnerValue) !== undefined)
                                            ? '+' + sideValues.find(e => e.name === '2to1_first').value * 2 : '-' + sideValues.find(e => e.name === '2to1_first').value : '2 to 1'
                                }

                            </span>
                        </td>
                        <td data-value="2 to 2"
                            onMouseEnter={e => hightlight2to1(2)}
                            onMouseLeave={e => cancelHighlight()}
                            onClick={props.wheelSpin === false ? e => {
                                addMultipleValues1To12([2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35])
                                calc1to18('2to1_second')
                                setSecondColumn(secondColumn + props.activeChip)
                            } : null}
                        >
                            <span data-value={props.wheelSpin === false ? secondColumn !== 0 ? secondColumn : null : ''}
                                className={`bottom-row number-table vertical-number-1 ${props.wheelSpin === true && sideValues.find(e => e.name == '2to1_second').value ? 'table-number-value win-color--blue minusResult' : secondColumn !== 0 ? getColor(secondColumn) + ' active-cursor' : ''}`}>

                                {
                                    props.wheelSpin === true && sideValues.find(e => e.name === '2to1_second').value ?
                                        ([2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35].find(e => e == props.winnerValue) !== undefined)
                                            ? '+' + sideValues.find(e => e.name === '2to1_second').value * 2 : '-' + sideValues.find(e => e.name === '2to1_second').value : '2 to 1'
                                }

                            </span>
                        </td>

                        <td data-value="2 to 3"
                            onMouseEnter={e => hightlight2to1(3)}
                            onMouseLeave={e => cancelHighlight()}
                            onClick={props.wheelSpin === false ? e => {
                                addMultipleValues1To12([3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36])
                                calc1to18('2to1_third')
                                setThirdColumn(thirdColumn + props.activeChip)
                            } : null}
                        >
                            <span data-value={props.wheelSpin === false ? thirdColumn !== 0 ? thirdColumn : null : ''}
                                className={`bottom-row number-table vertical-number-1 ${props.wheelSpin === true && sideValues.find(e => e.name == '2to1_third').value ? 'table-number-value win-color--blue minusResult' : thirdColumn !== 0 ? getColor(thirdColumn) + ' active-cursor' : ''}`}>

                                {
                                    props.wheelSpin === true && sideValues.find(e => e.name === '2to1_third').value ?
                                        ([3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36].find(e => e == props.winnerValue) !== undefined)
                                            ? '+' + sideValues.find(e => e.name === '2to1_third').value * 2 : '-' + sideValues.find(e => e.name === '2to1_third').value : '2 to 1'
                                }

                            </span>
                        </td>
                    </div>
                </tbody>
            </table>

        </div>
    );
}

export default BetTable;